import React, { useState,useEffect } from 'react'
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [shownav, setshownav] = useState(false)
  const toggleshow=()=>{
    setshownav(!shownav);

  }
  
  
  return (
    <header>
      
        <Link to="/" className='a'>
          <div className="logo"><span className='sas' >SAS</span> Tech</div>
          </Link>
        <nav className={shownav?"navmenu shownav":"navmenu"} id="navmenu">
            <Link to="/">Home</Link>
            {/* <Link to="/project">Projects</Link> */}
            <Link to="/contact">Contact us</Link>
        </nav>
        <div className={shownav?"navbtn hidebtn":"navbtn"} onClick={toggleshow} >
            <p></p>
            <p></p>
            <p></p>
        </div>
    </header>
  )
}
export default Navbar
